import { postRequest, ApiResponse } from "@/data/apiClient";

export interface UserUnsuspendResponse {
  id: number;
}

export async function userUnsuspend(
  userId: number
): Promise<ApiResponse<UserUnsuspendResponse>> {
  return postRequest("user/unsuspend", { userId });
}
